
// @codekit-prepend "../node_modules/slick-carousel/slick/slick.min.js";
// @codekit-prepend "../node_modules/isotope-layout/dist/isotope.pkgd.min.js";
// @codekit-prepend "../node_modules/aos/dist/aos.js";


var grid_element_collection = [];// All Grid Items witch should be watched

function reorder_isotope_items(big_img, grid_second_element, grid_third_image){
  let calc_big_img_height = grid_second_element.outerHeight() + grid_third_image.height();
  big_img.height(calc_big_img_height);
}

function trigger_image_reorder(){
  for(var i = 0; i < grid_element_collection.length; i++){
    reorder_isotope_items(grid_element_collection[i][0], grid_element_collection[i][1], grid_element_collection[i][2]);
  }
}
function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

jQuery(document).foundation();

jQuery(document).ready(function() {

  var position = jQuery(document).scrollTop();
  var document_height = jQuery(document).height();
  var windowHeight = jQuery(window).height();
  var adjusted_pos = 0;

  jQuery(window).scroll(function() {
      var scrollBottom = jQuery(window).scrollTop();
      var scroll = jQuery(document).scrollTop();
      windowHeight = jQuery(window).height();
      document_height = jQuery(document).height();
      adjusted_pos = document_height - windowHeight - 200;// Wenn scroll pos auf footer liegt, dann totop btn nicht zeigen

      if(scroll < position & scroll < adjusted_pos){
        jQuery(".totop").fadeIn();
        jQuery(".totop").addClass("act");
      }
      else{
        jQuery(".totop").fadeOut();
        jQuery(".totop").removeClass("act");
      }



      position = scroll;
  });



  jQuery('a').each(function() {
     var a = new RegExp('/' + window.location.host + '/');
     if (!a.test(this.href)) {
        jQuery(this).attr("target","_blank");
     }
  });

  // Fix wrong setted aos class, Aos breaks margins on overlay
  if(jQuery(".modul-overlay").length){
    let aos_items = jQuery(".modul-overlay-outer").find("[data-aos='fade-up']");
    aos_items.each(function(){
      jQuery(this).attr("data-aos", "");
    });
  }


  let scrollRef = 0;
  window.addEventListener('scroll', function() {
    scrollRef <= 10 ? scrollRef++ : AOS.refresh();
  });

  AOS.init({
    startEvent: 'DOMContentLoaded',
  });

  setTimeout(function(){
  jQuery(".front--overlay").fadeOut();
  }, 1000);


  jQuery("div.form-type-webform-terms-of-service label").html("Ich habe die <a href='/datenschutz' target='_blank' class='animation white show-border'>Datenschutzerklärung</a> gelesen und akzeptiere diese.");



  /* *************************************************************************** */

  jQuery('.modul-image_instagram_slider').each(function() {
    var slider = jQuery(this);

    slider.slick({
      dots: false,
      arrows: false,
      infinite: false,
      adaptiveHeight: true,
      slidesToShow: 4,
      responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 667,
            settings: {
              slidesToShow: 2.10
            }
          }
        ]


    });
  });

  /* *************************************************************************** */

  jQuery(".totop").click(function() {
    jQuery("html, body").animate({ scrollTop: 0 }, "fast");
    return false;
  });

  /* *************************************************************************** */

  jQuery('.modul-slider').each(function() {
    var slider = jQuery(this).find(".slider");
    var outer  = jQuery(this);

    slider.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
        var i = (currentSlide ? currentSlide : 0) + 1;
        var figHeight = slider.find("figcaption").outerHeight();
        outer.find(".modul-slider__count").html(i + '<i>&ndash;</i>' + slick.slideCount);
        outer.find(".modul-slider__count").css("bottom", figHeight+"px");

        outer.find("video").css("height", "100%");
        outer.find(".slick-current").prev().animate({ opacity: 0 }, 200, function() {});
        outer.find(".slick-current").animate({ opacity: 1 }, 200, function() {});
    });

    if(outer.hasClass("content-slider")) {
      slider.on(' afterChange', function(event, slick, currentSlide, nextSlide){
          var i = (currentSlide ? currentSlide : 0) + 1;
          outer.find(".modul-slider__inner_top_textelement").fadeOut();
          outer.find(".modul-slider__inner_top_textelement-"+i).delay(400).fadeIn();
      });
    }

    slider.slick({
      dots: false,
      arrows: false,
      adaptiveHeight: true,
      infinite: false,
      speed: 300,
      slidesToShow: 1.07
    });
  });

  /* *************************************************************************** */

  let iconMenu    = document.querySelector('button.hamburger span');
  let iconFilter  = document.querySelector('button.filter span');

  let iconMenuAnimation  = bodymovin.loadAnimation({
          container: iconMenu,
          renderer: 'svg',
          loop: false,
          autoplay: false,
          path: "/themes/dreia/lottie/menu.json"
  });

  let iconFilterAnimation  = bodymovin.loadAnimation({
          container: iconFilter,
          renderer: 'svg',
          loop: false,
          autoplay: false,
          path: "/themes/dreia/lottie/filter.json"
  });

  jQuery("body").on( "click", "button.hamburger span", function(e) {
    jQuery("body").toggleClass("noscroll");
    jQuery("nav, .menuopen, button.hamburger span, button.hamburger, main, .logo").toggleClass("active");
    if(jQuery("button.hamburger span").hasClass("active")) {
      iconMenuAnimation.playSegments([0,60], true);
    } else {
      iconMenuAnimation.playSegments([60,0], true);
    }
  });

  jQuery("body").on( "click", "button.filter span", function(e) {

    jQuery("button.filter span, button.filter").toggleClass("active");
    jQuery(".modul-projects_filter").slideToggle();
    if(jQuery("button.filter span").hasClass("active")) {
      iconFilterAnimation.playSegments([0,60], true);
    } else {
      iconFilterAnimation.playSegments([60,0], true);
    }
    jQuery("div.modul-projects_filter button").removeClass("active");
    jQuery("div.modul-projects_further .modul-projects_further_item").fadeIn();
    jQuery('.modul-projects .grid').isotope({ filter: '*' });
  });

  /* *************************************************************************** */


  jQuery("body").on( "click", "div.modul-projects_filter button", function(e) {
    jQuery(".modul-projects_all").hide();
    jQuery(".grid").show();
    jQuery(".modul-projects_further").show();
    if(jQuery(this).hasClass("active")) {
        jQuery("div.modul-projects_filter button").removeClass("active");
        jQuery("div.modul-projects_further .modul-projects_further_item").fadeIn();
        jQuery('.modul-projects .grid').isotope({ filter: '*' });
    } else {
      jQuery("div.modul-projects_filter button").removeClass("active");
      jQuery(this).addClass("active");
      var filter = jQuery(this).attr("data-filter")

      if(filter == "filter-werkverzeichnis") {
        jQuery(".modul-projects_all").show();
        jQuery(".modul-projects_further").hide();
        jQuery(".grid").hide();

      } else {
        jQuery('.modul-projects .grid').isotope({ filter: '.'+filter });
        jQuery("div.modul-projects_further .modul-projects_further_item").hide();
        jQuery("div.modul-projects_further .modul-projects_further_item."+filter).fadeIn();
      }

      var filterElem = jQuery(this).attr("data-filter");

      jQuery("div.modul-projects_item a").each(function() {
        var href = jQuery(this).attr('href');



        var $withoutHash = href.split('?')[0];
        jQuery(this).attr("href", $withoutHash+"?f="+filterElem);
      });


    }

    if(jQuery("div.modul-projects_further .modul-projects_further_item:visible").length == 0) {
      jQuery(".modul-projects_further").hide();
    } else {
      jQuery(".modul-projects_further").show();
    }


  });

  /* *************************************************************************** */

  jQuery("body").on( "click", "h2[data-showoverlay]", function(e) {
    var overlay = jQuery(this).attr("data-showoverlay");

    jQuery('div.modul-overlay-outer[data-overlay="'+overlay+'"]').addClass("active");
    jQuery(".main-overlay").fadeIn();
    jQuery("body").addClass("noscroll");
  });

  jQuery("body").on( "click", ".modul-overlay-outer-close, .main-overlay", function(e) {
    jQuery("body").removeClass("noscroll");
    jQuery('div.modul-overlay-outer').removeClass("active");
    jQuery(".main-overlay").fadeOut();
  });

  jQuery("body").on( "click", ".modul-news_grid_element", function(e) {
    jQuery(this).find(".modul-news_content").slideToggle( "fast", function() {
       jQuery('.modul-news .modul-news_grid').isotope();



     });
  });

  jQuery("body").on( "click", ".modul-faq h3", function(e) {
    jQuery(this).next().slideToggle();
  });
  jQuery("body").on( "click", ".modul-faq .modul-faq_content img", function(e) {
    jQuery(this).parent().slideToggle();
  });

});


jQuery(window).on('load', function () {
  if(jQuery("body").hasClass("page-node-29")) {
    jQuery(function() {
      var $ibWrapper	= jQuery('#ib-main-wrapper'),
      Template	= (function() {
        var kinetic_moving  = false,
          current						= -1,
          isAnimating				= false,
          $ibItems					= $ibWrapper.find('div.ib-main > .ib-item'),
          $ibImgItems				= $ibItems.not('.ib-content'),
          imgItemsCount			= $ibImgItems.length,

          init						  = function() {
            $ibImgItems.addClass('ib-image');

            loadKinetic();
            initEvents();
            // JC CUSTOM SCRIPT
            // Center Kinetic
            let left_pos = document.getElementById("ib-main-wrapper").scrollWidth / 2;
            let top_pos = document.getElementById("ib-main-wrapper").scrollHeight / 2;
            document.getElementById("ib-main-wrapper").scrollLeft = left_pos;
            document.getElementById("ib-main-wrapper").scrollTop = top_pos;
          },

          loadKinetic = function() {
            setWrapperSize();
            $ibWrapper.kinetic({
              moved	: function() {
                kinetic_moving = true;
              },
              stopped	: function() {
                kinetic_moving = false;
              }
            });
          },

          setWrapperSize = function() {
            $ibWrapper.css( 'height', jQuery(window).height())
          },

          initEvents = function() {

            // open the item only if not dragging the container
            if(jQuery(window).width() > 1024){
              $ibItems.bind('click.ibTemplate', function( event ) {
                if( !kinetic_moving ) {
                  window.location.href = jQuery(this).attr("href");
                }
                return false;
              });
            }



            jQuery(window).bind('resize.ibTemplate', function( event ) {
              setWrapperSize();
              jQuery('#ib-img-preview, #ib-content-preview').css({
                width	: jQuery(window).width(),
                height	: jQuery(window).height()
              })

            });
          },

          // get the size of one image to make it full size and centered
          getImageDim					= function( src ) {

            var img     	= new Image();
            img.src     	= src;

            var w_w	= jQuery(window).width(),
              w_h	= jQuery(window).height(),
              r_w	= w_h / w_w,
              i_w	= img.width,
              i_h	= img.height,
              r_i	= i_h / i_w,
              new_w, new_h,
              new_left, new_top;

            if( r_w > r_i ) {

              new_h	= w_h;
              new_w	= w_h / r_i;

            }
            else {
              new_h	= w_w * r_i;
              new_w	= w_w;

            }

            return {
              width	: new_w,
              height	: new_h,
              left	: (w_w - new_w) / 2,
              top		: (w_h - new_h) / 2
            };

          };

        return { init : init };

      })();
      Template.init();
    });

  }






  jQuery('.modul-projects .grid').isotope({
    itemSelector: '.modul-projects_item',
  });

  jQuery('.modul-news .modul-news_grid').isotope({
    itemSelector: '.modul-news_grid_element',
  });

  /*
  jQuery('.modul-news .modul-news_grid').isotope({
    layoutMode: 'fitRows',
    itemSelector: '.modul-news_grid_element'
   });
  */


  if(getParameterByName('f')) {
    console.log("LICK");
    jQuery("button.filter span").trigger("click");
    var filt = getParameterByName('f');
    jQuery('div.modul-projects_filter button[data-filter="'+filt+'"]').trigger("click");

    jQuery('div.modul-projects_filter button[data-filter="'+filt+'"]').addClass("active");

/*
    var $gridNew  = jQuery('.modul-projects .grid').isotope({
      itemSelector: '.modul-projects_item',
    });


    $gridNew.on( 'arrangeComplete', onArrange );

  */
  }

  function onArrange() {
    console.log('arrange done');
    let target_url = window.location.search;
    target_url  = target_url.split("?el=")[1]; // GET Parameter

    if(target_url.indexOf('&') != "-1") {
      target_url = target_url.substring(0, target_url.indexOf('&'));
    }



    //Search Target Link Item
    if(target_url != null & target_url != "" & target_url != "undefined"){
      jQuery("a.href-back-target").each(function(){
        let url = jQuery(this).data("url_id");
        if(url == target_url){
          jQuery("html, body").animate({
            scrollTop: jQuery(this).offset().top
          }, 1);
          return false;
        }
      });
    }
  }

  if(jQuery(".modul-uns_grid").length){
    if(jQuery(window).width() > 768){
      jQuery(".modul-uns_grid_element__1").each(function(){
        let big_img_element = jQuery(this).find("img");// Big Grid image

        // Set Image Opacity and background image
        let img_src = big_img_element.prop("src");
        big_img_element.css("opacity", 0);
        big_img_element.parent().css("background-image", "url(" + img_src + ")");

        let grid_second_element = jQuery(this).next();// Next Element
        let grid_third_image = jQuery(this).next().next().find("img");// Image from third element
        let watch_images_collection = [big_img_element, grid_second_element, grid_third_image];// Create Array with the elements
        grid_element_collection.push(watch_images_collection);// Push to collection
      });
      // Trigger image resize initial
      trigger_image_reorder();
    }
  }

  jQuery('.modul-uns .modul-uns_grid').isotope({
    itemSelector: '.modul-uns_grid_element',
  });

  // Fix mobile no href mainpage
  /*
  jQuery(".ib-image").on("click", function(){
    let target_url = jQuery(this).attr("data");
    alert(target_url);
    window.location.href = target_url;
  });
  */

  // Subpage go Back Scipt
  let target_url = window.location.search;
  target_url  = target_url.split("?el=")[1]; // GET Parameter

  if(target_url.indexOf('&') != "-1") {
    target_url = target_url.substring(0, target_url.indexOf('&'));
  }

  //Search Target Link Item
  if(target_url != null && target_url != "" && target_url != "undefined" && getParameterByName('f') == null){
    console.log("XXXXXX");
    jQuery("a.href-back-target").each(function(){
      let url = jQuery(this).data("url_id");
      if(url == target_url){
        jQuery("html, body").animate({
          scrollTop: jQuery(this).offset().top
        }, 1);
        return false;
      }
    });
  }

  jQuery(window).on("resize", function(){
    if(jQuery(window).width() > 768){
      trigger_image_reorder();
    }
  });
});
